const SvgIconLinkedin = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg fill="none" viewBox="0 0 16 16" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M4.627 3.333a1.333 1.333 0 1 1-2.667-.001 1.333 1.333 0 0 1 2.667.001Zm.04 2.32H2V14h2.667V5.653Zm4.213 0H6.227V14h2.626V9.62c0-2.44 3.18-2.667 3.18 0V14h2.634V8.713c0-4.113-4.707-3.96-5.814-1.94l.027-1.12Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgIconLinkedin
